export class QRCodeData {
    public fullName: string | null;
    public birthDate: string | null;
    public url: string | null;
};
